<template>
	<div class="placeholder flex flex-col items-center gap-03 rounded bg-ink-inverted-12 pb-06 pt-07">
		<Icon name="alert" size="1.25" />
		<div>
			<T :path="singleStore ? 'noStores.descSpecificStore' : 'noStores.desc'">
				<template #discounts>
					<span class="font-bold"><I18n path="noStores.discounts" /></span>
				</template>
			</T>
		</div>

		<template v-if="isEmbedded">
			<Button v-if="hasScrapersEnabled" size="s" @click="setupSource"><I18n path="noStores.setupSource" /></Button>
			<div v-else><I18n path="noStores.contactAdminToSetupSource" /></div>
		</template>

		<div class="mt-06">
			<I18n path="noStores.reloadOnceReady" />

			<div class="mt-04 text-center">
				<Button variant="secondary" size="s" width="normal" @click="reload">
					<I18n path="noStores.reloadAction" />
				</Button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Button, I18n, Icon } from '@bluebrick/saas-ui'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/features/app/useAppStore'
import { emitToParent } from '@/features/iframe/useParentEmit'
import { useTelemetry } from '@/features/telemetry/useTelemetry'
import { useFeatureFlagStore } from '@/features/user/useFeatureFlagStore'
import T from '@/translations/T.vue'

const { trackEvent } = useTelemetry()
const { hasScrapersEnabled } = storeToRefs(useFeatureFlagStore())
const { isEmbedded } = storeToRefs(useAppStore())

defineProps<{
	singleStore?: boolean
}>()

const emit = defineEmits(['reload'])

function setupSource() {
	trackEvent('user', 'Choose to setup first source from no-sources-setup view.')
	emitToParent('OPEN_SOURCES_TAB')
}

function reload() {
	trackEvent('user', 'Clicked reload in No Stores Placeholder.')

	emit('reload')
}
</script>

<style lang="scss" scoped>
.placeholder {
	border: 0.0625rem solid theme('colors.ink.12');
}
</style>
